<script>
export default {
  data: () => ({
    dataGroups: [
      {
        name: 'Broiler Batches',
        url: 'v1/dataAdmin/raw-broiler-batches',
        busyLoading: false,
        jsonData: '',
      },
      {
        name: 'Layer Batches',
        url: 'v1/dataAdmin/raw-layer-batches',
        busyLoading: false,
        jsonData: '',
      },
    ],
  }),

  methods: {
    onGroupExecuted(group, result) {
      group.jsonData = JSON.stringify(result, null, '  ');
    },
  },

}
</script>

<template>
  <b-card no-body>
    <b-tabs card>

      <b-tab v-for="group in dataGroups" :key="group.name" :title="group.name">

        <api-button
          method="get"
          :url="group.url"
          class="btn btn-primary mb-2"
          @executed="onGroupExecuted(group, $event)">
          <i class="fa fa-download"></i>
          Load {{group.name}}
        </api-button>

        <textarea :value="group.jsonData" readonly rows="20" max-rows="50" class="w-100 bg-dark text-light small"></textarea>

      </b-tab>

    </b-tabs>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/views/ExportDataView.vue